
$(function() {
	// checkCustomInputs();

    $('[data-background], img[data-src]').imageLoader();

    // Open popup links inside a modal
	$(document).on('click', 'a.popup', function(e) {
		e.preventDefault();
		window.top.openIframePopup($(this).attr('href'));
	});

	// Make sure internal links inside popups are opened correctly
	$('body.popup .text a[href^="/"]').addClass('popup');

	// Make sure external links inside popups are opened in a new window
	$('body.popup a[href^="http"]').attr('target', '_blank');

	$('body').tooltip({
		selector: '[data-bs-toggle="tooltip"]',
		offset: "0, 5",
		delay: 300
	});

	// flags bij messages uitklappen:
    // $('a.actions-selected').click(function() {
    //
    // 	$('.message-flags').fadeOut(200);
    //
    // 	var showContainer = $(this).data('container');
    //
    // 	console.log(showContainer);
    //
    //     if ($('.'+showContainer+'').is(':visible')) {
    //         $('.'+showContainer).hide();
    //     } else {
    //         $('.'+showContainer).show();
    //     }
    //
    //     return false;
    // });
    //
	// // fade out van flags bij messages
	// $('.message-flags').hover(
	// 	function(){},
	// 	function(){
	// 		$(this).fadeOut(200);
	// 	}
	// );


    $(document).on('click', 'a.confirm', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $popin    = $('#confirm-modal');
        var textYes   = $(this).data('text-yes') || $popin.find('.yes').data('text-yes');
        var textNo    = $(this).data('text-no')  || $popin.find('.no').data('text-no');
        var onConfirm = $(this).data('onconfirm') || '';

        if ($popin.is(':visible')) {
            return;
        }

        $popin.find('.text').html($(this).data('confirm'));
        $popin.find('.yes').removeAttr('onclick').attr('href', $(this).attr('href')).text(textYes);
        $popin.find('.no').text(textNo);
        $popin.modal('show');

        if (onConfirm) {
            $popin.find('.yes').attr('onclick', onConfirm);
        }
    });

    $(document).on('click', 'a.show-alert', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $popin = $('#alert-modal');

        if ($popin.is(':visible')) {
            return;
        }

        $popin.find('.text').html($(this).data('alert'));
        $popin.modal('show');
    });

    $('input[type=number]').on('input', function() {
        var min       = parseInt($(this).attr('min'));
        var max       = parseInt($(this).attr('max'));
		var maxLength = parseInt($(this).attr('maxlength'));
        var value     = parseInt($(this).val());

        if (!isNaN(max) && value > max) {
            $(this).val(max);
        }

        if (!isNaN(min) && value < min) {
            $(this).val(min);
        }

		if (!isNaN(maxLength)) {
			$(this).val($(this).val().substring(0, maxLength));
		}
    });

	$(document).on('click', '.btn', function(e) {
		var $btn = $(this);
		$btn.addClass('clicked');

		setTimeout(function() {
			$btn.removeClass('clicked');
		}, 100);
	});

	$('.toggle-pass').on('mousedown', function(e) {
		e.preventDefault();

		var $passField = $(this).parent().find('input');
		var $icon      = $(this).find('i');
		var newType    = $passField.attr('type') === 'text' ? 'password' : 'text';

		$passField.attr('type', newType).focus();
		newType === 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
	}).on('click', function(e) {
		e.preventDefault();
	});

   	$('.modal').on('show.bs.modal', function(e) {
   		$('body').addClass('modal-active');
   	}).on('hide.bs.modal', function(e) {
   		$('body').removeClass('modal-active');
   	}).on('shown.bs.modal', function() {
		$('[data-bs-toggle="tooltip"]').tooltip('hide');
	});

	$('select').on('change empty-init', function() {
		$(this).toggleClass('empty', $(this).val() === '');
	}).trigger('empty-init');
});

$(window).on('resize resize-init', function() {
	checkSidebarHeight();
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
}).trigger('resize-init');

$(window).on('scroll', function() {
	var scrollTop = $(this).scrollTop();

	if (scrollTop > 0) {
		$('body').addClass('scrolled');
	} else {
		$('body').removeClass('scrolled');
	}
}).trigger('scroll')

var dateTimePickerIcons = {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-double-left',
    next: 'fa fa-chevron-double-right',
    today: 'fa fa-crosshairs',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
};


$(window).on('mousewheel', function() {
    $(window).trigger('scroll');
});

setInterval(function() {
    $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
